import {
    ACTIVE_SERVICES_REQUEST_STARTED,
    ACTIVE_SERVICES_REQUEST_FINISHED,
    ACTIVE_SERVICES_REQUEST_FAILED,
    PROVISIONING_STATUS_REQUEST_STARTED,
    PROVISIONING_STATUS_REQUEST_FINISHED,
    PROVISIONING_STATUS_REQUEST_FAILED,
    PROVISIONING_SET_ACCOUNT_NUMBER,
    PROVISIONING_SET_SERVICE_ORDER_NUMBER,
} from 'constants/actionTypes';

export const setProvisioningSearchAccountNumber = (value) => ({type: PROVISIONING_SET_ACCOUNT_NUMBER, value});
export const getActiveServicesStarted = (accountNumber) => ({type: ACTIVE_SERVICES_REQUEST_STARTED, accountNumber});
export const getActiveServicesFinished = (payload, accountNumber) => ({type: ACTIVE_SERVICES_REQUEST_FINISHED, payload, accountNumber});
export const getActiveServicesFailed = (payload, accountNumber) => ({type: ACTIVE_SERVICES_REQUEST_FAILED, payload, accountNumber});

export const setProvisioningSearchServiceOrderNumber = (value) => ({type: PROVISIONING_SET_SERVICE_ORDER_NUMBER, value});
export const getProvisioningStatusStarted = (serviceNo, accountNumber) => ({type: PROVISIONING_STATUS_REQUEST_STARTED, serviceNo, accountNumber});
export const getProvisioningStatusFinished = (payload, serviceNo, accountNumber) => ({type: PROVISIONING_STATUS_REQUEST_FINISHED, payload, serviceNo, accountNumber});
export const getProvisioningStatusFailed = (payload, serviceNo, accountNumber) => ({type: PROVISIONING_STATUS_REQUEST_FAILED, payload, serviceNo, accountNumber});



// WEBPACK FOOTER //
// ./src/actions/provisioningActions.js